export type StreamingV2InitResponse = {
  sessionId: string;
  uploadId: string;
  key: string;
  minChunkSizeInBytes: number;
  recommendedChunkSizeInBytes: number;
};

export type StreamingV2ChunkResponse = {
  partNumber: number;
  eTag: string;
  chunkSizeInBytes: number;
};

export type StreamingV2CompleteRequest = {
  sessionId: string;
  uploadId: string;
  key: string;
  fileName: string;
  parts: Array<{ partNumber: number; eTag: string }>;
};

export type StreamingV2CompleteResponse = {
  key: string;
  sessionId: string;
  sessionFileId: string;
};

/**
 * Intermediate multipart upload state preserved between retries.
 * Stored in a ref so retryFile() can resume from the last successful chunk
 * instead of re-uploading from scratch.
 */
export interface UploadContext {
  sessionId: string;
  uploadId: string;
  objectKey: string;
  chunkSize: number;
  totalChunks: number;
  totalBytes: number;
  completedParts: Array<{ partNumber: number; eTag: string }>;
}

/** HTTP status codes that indicate a permanent error — no point retrying. */
export const PERMANENT_ERROR_CODES = new Set([400, 404, 409, 413, 415, 422, 500, 501]);
